(() => {
  if (window.__HC_CUSTOM_FACETS_R26_LOADED__) return;
  window.__HC_CUSTOM_FACETS_R26_LOADED__ = true;

  const selector = '[data-hc-fallback-facet]';
  let navigationInProgress = false;

  const getCollectionPath = () => {
    const parts = window.location.pathname.split('/').filter(Boolean);
    const collectionIndex = parts.indexOf('collections');
    if (collectionIndex === -1 || !parts[collectionIndex + 1]) return null;

    const baseParts = parts.slice(0, collectionIndex + 2);
    const tagSegment = parts[collectionIndex + 2] || '';
    const tags = tagSegment.split('+').map((tag) => tag.trim()).filter(Boolean);

    return { baseParts, tags };
  };

  const cleanLegacyMetafieldParams = () => {
    if (!document.querySelector(selector)) return false;

    const url = new URL(window.location.href);
    const collectionPath = getCollectionPath();
    if (!collectionPath) return false;

    const migrations = [
      ['filter.p.m.custom.era', 'hc-era-'],
      ['filter.p.m.custom.grading_company', 'hc-grader-'],
      ['filter.p.m.custom.grade_filter', 'hc-grade-'],
      ['filter.p.m.custom.grade', 'hc-grade-'],
    ];

    let changed = false;
    const tags = [...collectionPath.tags];

    migrations.forEach(([param, prefix]) => {
      const raw = url.searchParams.get(param);
      if (!raw) return;

      changed = true;
      url.searchParams.delete(param);

      for (let i = tags.length - 1; i >= 0; i -= 1) {
        if (tags[i].startsWith(prefix)) tags.splice(i, 1);
      }

      const firstValue = raw.split(',')[0]?.trim();
      if (firstValue) {
        const suffix = firstValue.toLowerCase().replace(/\./g, '-').replace(/[^a-z0-9-]+/g, '-').replace(/^-+|-+$/g, '');
        if (suffix) tags.push(`${prefix}${suffix}`);
      }
    });

    if (!changed) return false;

    const path = `/${collectionPath.baseParts.join('/')}${tags.length ? `/${tags.join('+')}` : ''}`;
    url.pathname = path;
    url.searchParams.delete('page');

    if (url.toString() !== window.location.href) window.location.replace(url.toString());
    return true;
  };

  const syncFacet = (facet) => {
    const prefix = facet.dataset.tagPrefix;
    const collectionPath = getCollectionPath();
    if (!prefix || !collectionPath) return;

    const selectedTag = collectionPath.tags.find((tag) => tag.startsWith(prefix));
    const inputs = [...facet.querySelectorAll('[data-hc-fallback-input]')];

    inputs.forEach((input) => {
      input.checked = input.value === selectedTag;
    });

    const status = facet.querySelector('[data-hc-fallback-status]');
    if (status) {
      const selectedInput = inputs.find((input) => input.checked);
      status.textContent = selectedInput?.dataset.hcLabel || '';
      status.classList.remove('facets__bubble');
    }
  };

  const updateFromFacet = (facet, changedInput) => {
    if (navigationInProgress) return;

    const prefix = facet.dataset.tagPrefix;
    const collectionPath = getCollectionPath();
    if (!prefix || !collectionPath) return;

    const tags = collectionPath.tags.filter((tag) => !tag.startsWith(prefix));

    if (changedInput.checked) {
      facet.querySelectorAll('[data-hc-fallback-input]').forEach((input) => {
        if (input !== changedInput) input.checked = false;
      });
      tags.push(changedInput.value);
    }

    const url = new URL(window.location.href);
    const path = `/${collectionPath.baseParts.join('/')}${tags.length ? `/${tags.join('+')}` : ''}`;
    url.pathname = path;
    url.searchParams.delete('filter.p.m.custom.era');
    url.searchParams.delete('filter.p.m.custom.grading_company');
    url.searchParams.delete('filter.p.m.custom.grade_filter');
    url.searchParams.delete('filter.p.m.custom.grade');
    url.searchParams.delete('page');

    if (url.toString() === window.location.href) return;

    navigationInProgress = true;
    changedInput.disabled = true;
    requestAnimationFrame(() => window.location.assign(url.toString()));
  };

  const initialize = () => {
    if (cleanLegacyMetafieldParams()) return;
    document.querySelectorAll(selector).forEach(syncFacet);
  };

  document.addEventListener('change', (event) => {
    const input = event.target.closest?.('[data-hc-fallback-input]');
    if (!input) return;
    const facet = input.closest(selector);
    if (facet) updateFromFacet(facet, input);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', initialize);
})();
